// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".v-list--dense .v-list-item[data-v-eb765160],.v-list-item--dense[data-v-eb765160]{min-height:34px}", ""]);
// Exports
module.exports = exports;
